import { Globe } from 'lucide-react';
import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu';
import { LOCALES, LOCALE_LABELS, useI18n, type Locale } from '../i18n';

/**
 * Language selector rendered as a submenu, designed to slot into an existing
 * DropdownMenu (e.g. the sidebar user menu). Changing the locale updates the
 * whole app and persists the choice to the shared `queri_lang` cookie.
 */
export function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();
  const current = LOCALE_LABELS[locale];

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <Globe className="mr-2 h-4 w-4" />
        <span className="flex-1">{t.common.switcher.label}</span>
        <span className="ml-2 text-xs text-muted-foreground" aria-hidden>
          {current.flag} {current.short}
        </span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        <DropdownMenuRadioGroup
          value={locale}
          onValueChange={(value) => setLocale(value as Locale)}
        >
          {LOCALES.map((code) => {
            const opt = LOCALE_LABELS[code];
            return (
              <DropdownMenuRadioItem
                key={code}
                value={code}
                className="cursor-pointer gap-2"
              >
                <span className="text-base leading-none" aria-hidden>
                  {opt.flag}
                </span>
                <span>{opt.label}</span>
              </DropdownMenuRadioItem>
            );
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}

export default LanguageSwitcher;
